import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const PowerCard = ({ direction, number, title, description, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); 
        };
    handleResize(); 
    window.addEventListener("resize", handleResize); // Listen for window resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  return (
    <motion.div
      ref={ref}
      className="flex-1 min-w-[300px] bg-gray-200 p-6 rounded-xl h-44 sm:h-40 md:h-48 lg:h-60 flex flex-col justify-center items-center shadow-card-border transition-colors duration-300"
      initial={{
        x: isMobile ? 0 : direction === "left" ? "-20%" : "20%",
        y: isMobile ? "50%" : 0,
        opacity: 0,
      }}
      animate={{
        x: inView ? 0 : isMobile ? 0 : direction === "left" ? "-20%" : "20%",
        y: inView ? 0 : isMobile ? "50%" : 0,
        opacity: inView ? 1 : 0,
      }}
      transition={{ duration: 1, delay: delay }}
    >
      <h1 className="text-xl sm:text-xl md:text-xl lg:text-5xl font-semibold mb-4 text-primary">{number}</h1>
      <h2 className="text-xl sm:text-lg md:text-xl lg:text-3xl font-semibold mb-2 text-primary">{title}</h2>
      <p className="text-[12px] sm:text-[12px] md:text-sm lg:text-base text-gray-500 text-center mb-4">
        {description}
      </p>
    </motion.div>
  );
};

export default PowerCard;
